import { customFetch, appendFormDataWithObjectValues } from 'utils/http';
import { HTTPResponseError, RewardAmountExceedsTheBalance } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';

type Params = {
  idPayment: number;
  amount: string;
  comment: string;
};

export const updatePartnerPayment = async (params: Params): Promise<void> => {
  const body = new FormData();

  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(getM8AdminURL('updatePartnerPayment'), {
    method: 'PUT',
    body,
  });

  if (!response.ok) {
    if (response.status === 400) {
      throw new RewardAmountExceedsTheBalance();
    }

    throw new HTTPResponseError(response);
  }
};
